<script lang="ts">
import type { NavigationNode } from '../../../../types/link';
import Button1XP from '../../../Button1XP/Button1XP.vue';
type Props = {
  item: NavigationNode;
  endIcon?: string;
  controls: string;
  level: number;
  isLastNavItem?: boolean;
};
</script>
<script setup lang="ts">
defineProps<Props>();
const emit = defineEmits(['itemClick']);
</script>
<template>
  <Button1XP
    v-if="item.children?.length"
    :id="item._id"
    :aria-controls="controls"
    :end-icon="endIcon"
    :target="item.newWindow ? '_blank' : '_self'"
    :text="item.label"
    variant="linkStatic"
    @click="
      (e) =>
        emit('itemClick', {
          event: e,
          shouldActivateLevel: level,
          activeLinkId: item._id,
          activeLinkLabel: item.label,
        })
    "
  />
  <a
    v-else-if="item.url && item.label"
    :id="item._id"
    :href="item.url"
    :target="item.newWindow ? '_blank' : '_self'"
    @click="
      (e) =>
        emit('itemClick', {
          event: e,
          shouldActivateLevel: 0,
          activeLinkId: item._id,
          activeLinkLabel: item.label,
        })
    "
  >
    <div :class="$style.teaserImg">
      <img
        v-if="isLastNavItem && (item.media || item.image)"
        alt=""
        loading="lazy"
        :src="item.media || item.image"
      />
    </div>
    <span :aria-hidden="true" v-html="item.label" />
    <span class="accessible-link-text">{{ item.label }}</span>
  </a>
</template>
<style lang="scss" module src="../../MainNav.scss" />
